module.exports = new __parcel__URL__("macpractice-icon.87d6b777.jpg").toString();